import { render, staticRenderFns } from "./TaskLoader.vue?vue&type=template&id=4778c3a8&scoped=true&"
import script from "./TaskLoader.vue?vue&type=script&lang=js&"
export * from "./TaskLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4778c3a8",
  null
  
)

export default component.exports